import { convertTo12HourFormat } from "../../../../../helpers/helpers";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadingSkeleton from "../../../../loader/TableLoader";
import Pagination from "../../../../commanPage/pagination/Pagination";

function ConfirmPaymentTable({ setCheckedValue, checkedValue, totalItem }) {
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [auctionData, setAuctionData] = useState([]);
  const [selectAll, setSelectAll] = useState(true);
  const [checkedRows, setCheckedRows] = useState({});
  const [currentPage, setCurrentPage] = useState(0);

  const { loadings, confirmlotsPayment, remainUncheck } = useSelector(
    (state) => state?.confirmPaymentsLots
  );

  useEffect(() => {
    if (confirmlotsPayment) {
      const updatedAuctionData = confirmlotsPayment.map((offer) => ({
        ...offer,
        status: true,
      }));
      const updatedAuctionDataUnchecked = remainUncheck.map((offer) => ({
        ...offer,
        status: true,
      }));
      setAuctionData([...updatedAuctionData, ...updatedAuctionDataUnchecked]);

      const initialCheckedRows = {};
      updatedAuctionData.forEach((item) => {
        initialCheckedRows[item._id] = true;
      });
      setCheckedRows(initialCheckedRows);
      setCheckedValue(updatedAuctionData);
    }
  }, [confirmlotsPayment]);

  // Function to toggle individual row checkbox
  const handleRowToggle = (id) => {
    setCheckedRows((prevCheckedRows) => ({
      ...prevCheckedRows,
      [id]: !prevCheckedRows[id],
    }));

    // Check if checkbox is true and add the object to checkedValue array
    if (!checkedRows[id]) {
      setCheckedValue([
        ...checkedValue,
        auctionData.find((item) => item._id === id),
      ]);
    } else {
      setCheckedValue(checkedValue.filter((item) => item._id !== id));
    }
  };
  // Function to toggle header checkbox
  const handleHeaderToggle = () => {
    setSelectAll(!selectAll);
    const newCheckedRows = {};
    auctionData.forEach((item) => {
      newCheckedRows[item._id] = !selectAll;
    });
    setCheckedRows(newCheckedRows);
    if (!selectAll) {
      setCheckedValue(auctionData);
    } else {
      setCheckedValue([]);
    }
  };

  return (
    <>
      {loadings ? (
        <div className="valign-wrapper justify-center cover white">
          <LoadingSkeleton
            headerData={[
              "offer No.",
              "Scrap Type",
              "Lot Time",
              "Quantity / UOM",
              "EMD Amount (Rs.)",
            ]}
          />
        </div>
      ) : (
        <>
          <div className={`${!isTablet && " table-container-style"}`}>
            <table
              className={`responsive-table centered pointer ${
                isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
            >
              <thead>
                <tr>
                  <th>
                    <span
                      className="material-icons-outlined pointer checkToggle"
                      onClick={handleHeaderToggle}
                      style={{
                        paddingTop: !isTablet ? "5px" : "unset",
                      }}
                    >
                      {selectAll && checkedValue?.length === auctionData?.length
                        ? "check_box"
                        : "check_box_outline_blank"}
                    </span>
                  </th>
                  <th>Lot No</th>
                  <th>Scrap Type</th>
                  <th>Lot Time</th>
                  <th>Quantity / UOM</th>
                  <th>EMD Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                {auctionData
                  ?.slice(currentPage, currentPage + totalItem)
                  ?.map((item,index) => (
                    <tr key={item._id}>
                      <td style={{ width: "100px" }}>
                        <span
                          className="material-icons-outlined pointer checkToggle"
                          onClick={() => handleRowToggle(item._id)}
                          style={{
                            paddingTop: !isTablet ? "5px" : "unset",
                          }}
                        >
                          {checkedRows[item._id]
                            ? "check_box"
                            : "check_box_outline_blank"}
                        </span>
                      </td>
                      <td>{index+1}</td>
                      <td>{item?.scrapDetails?.type}</td>
                      <td>{`${convertTo12HourFormat(
                        item?.offerSchedule?.startTimeAndDate
                      )} - ${convertTo12HourFormat(
                        item?.offerSchedule?.endTimeAndDate
                      )}`}</td>
                      <td>{`${item?.scrapDetails?.quantity} / ${item?.scrapDetails?.unit}`}</td>
                      <td>{item?.EMDAmount}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {auctionData?.length > totalItem && (
            <Pagination
              Data={auctionData}
              totalNumberRow={totalItem}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}
    </>
  );
}

export default ConfirmPaymentTable;
